import script from "./ViewPVMemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPVMemoPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPVMemoPage.vue?vue&type=style&index=0&id=4eb49cd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb49cd2"]])

export default __exports__